import { ACTIVE_BASE_REST } from '@/api/constants'
import ApiCore from '@/api/api-core'

export default class SystemConfig extends ApiCore {
  constructor(store) {
    const path = `${ACTIVE_BASE_REST}/setting`
    super(store, path)
  }

  getUserConfigs(showProgress) {
    return this._request({
      action: 'user',
      method: 'GET',
      showProgress
    })
  }

  updateUserConfigs(model, showProgress) {
    return this._request({
      action: 'user',
      method: 'PUT',
      body: model,
      showProgress
    })
  }

  getSecurityConfigs(showProgress) {
    return this._request({
      action: 'security',
      method: 'GET',
      showProgress
    })
  }

  updateSecurityConfigs(model, showProgress) {
    return this._request({
      action: 'security',
      method: 'PUT',
      body: model,
      showProgress
    })
  }

  getOrderConfigs(showProgress) {
    return this._request({
      action: 'order',
      method: 'GET',
      showProgress
    })
  }

  updateOrderConfigs(model, showProgress) {
    return this._request({
      action: 'order',
      method: 'PUT',
      body: model,
      showProgress
    })
  }

  //driver
  getDriverConfigs(showProgress) {
    return this._request({
      action: 'driver',
      method: 'GET',
      showProgress
    })
  }

  updateDriverConfigs(model, showProgress) {
    return this._request({
      action: 'driver',
      method: 'PUT',
      body: model,
      showProgress
    })
  }
}
